import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Zap } from 'lucide-react';

// Custom SVG Icons for Quick Services - Premium Redesigned
const VideoConsultationIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="video-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#286CFF', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#5B8BFF', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="28" fill="url(#video-grad)" opacity="0.1"/>
    <rect x="16" y="22" width="22" height="18" rx="3" fill="url(#video-grad)"/>
    <circle cx="27" cy="31" r="5" fill="white"/>
    <circle cx="26" cy="30" r="2" fill="#286CFF"/>
    <path d="M22 35C22 35 24 37 27 37C30 37 32 35 32 35" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <path d="M38 26L48 20V42L38 36V26Z" fill="url(#video-grad)"/>
    <circle cx="44" cy="24" r="3" fill="#FF6B6B">
      <animate attributeName="opacity" values="1;0.3;1" dur="2s" repeatCount="indefinite"/>
    </circle>
  </svg>
);

const FindDoctorsIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="doctor-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#28C08A', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#1E8E6F', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="28" fill="url(#doctor-grad)" opacity="0.1"/>
    <circle cx="32" cy="26" r="8" fill="url(#doctor-grad)"/>
    <path d="M32 22V26M30 24H34" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M20 36C20 36 23 34 32 34C41 34 44 36 44 36L44 46C44 48 42 50 40 50H24C22 50 20 48 20 46Z" fill="url(#doctor-grad)"/>
    <path d="M32 12L36 20L44 21L38 27L40 35L32 31L24 35L26 27L20 21L28 20L32 12Z" fill="#FFD700" opacity="0.8"/>
    <circle cx="44" cy="44" r="9" fill="#286CFF"/>
    <path d="M41 44L43 46L47 42" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const LabTestsIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="lab-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#286CFF', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#1E5ABF', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="28" fill="url(#lab-grad)" opacity="0.1"/>
    <path d="M24 14H26V26L20 42C19 44 20 47 22 47H42C44 47 45 44 44 42L38 26V14H40" stroke="url(#lab-grad)" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
    <rect x="24" y="14" width="16" height="3" fill="url(#lab-grad)" rx="1.5"/>
    <ellipse cx="32" cy="40" rx="9" ry="4" fill="#79A8FF" opacity="0.5"/>
    <circle cx="28" cy="33" r="2" fill="#28C08A"/>
    <circle cx="36" cy="35" r="2" fill="#FF6B6B"/>
    <circle cx="32" cy="31" r="2" fill="#FFD28A"/>
    <rect x="46" y="20" width="3" height="8" rx="1.5" fill="#286CFF"/>
    <rect x="50" y="18" width="3" height="10" rx="1.5" fill="#5B8BFF"/>
    <rect x="54" y="22" width="3" height="6" rx="1.5" fill="#79A8FF"/>
  </svg>
);

const BookAppointmentsIcon = () => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="appt-grad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#FFD28A', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#FFA94D', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <circle cx="32" cy="32" r="28" fill="url(#appt-grad)" opacity="0.1"/>
    <rect x="18" y="18" width="28" height="28" rx="4" fill="white" stroke="url(#appt-grad)" strokeWidth="2.5"/>
    <rect x="18" y="18" width="28" height="8" fill="url(#appt-grad)" rx="4"/>
    <circle cx="24" cy="16" r="2.5" fill="url(#appt-grad)"/>
    <circle cx="40" cy="16" r="2.5" fill="url(#appt-grad)"/>
    <line x1="22" y1="30" x2="42" y2="30" stroke="#E0E0E0" strokeWidth="1.5"/>
    <line x1="22" y1="35" x2="42" y2="35" stroke="#E0E0E0" strokeWidth="1.5"/>
    <line x1="22" y1="40" x2="42" y2="40" stroke="#E0E0E0" strokeWidth="1.5"/>
    <circle cx="26" cy="35" r="2.5" fill="#28C08A"/>
    <path d="M25 35L25.7 35.7L27.5 34" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="38" cy="40" r="2.5" fill="#FFD28A"/>
    <path d="M37 40L39 40M38 39L38 41" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

const QuickServices = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const carouselRef = useRef(null);

  const services = [
    {
      id: 1,
      icon: VideoConsultationIcon,
      title: 'Video Consultation',
      description: 'Connect with doctors instantly via secure video calls',
      badge: 'Available 24/7',
      badgeColor: '#286CFF',
      gradient: 'linear-gradient(135deg, #E3EDFF 0%, #F0F6FF 100%)',
      borderGradient: 'linear-gradient(135deg, #286CFF, #5B8BFF)',
      glowColor: '#286CFF',
      link: '/video-consultations'
    },
    {
      id: 2,
      icon: FindDoctorsIcon,
      title: 'Find Doctors Near You',
      description: 'Book confirmed appointments with verified doctors',
      badge: 'Verified Doctors',
      badgeColor: '#28C08A',
      gradient: 'linear-gradient(135deg, #E8F5F1 0%, #F0FAF6 100%)',
      borderGradient: 'linear-gradient(135deg, #28C08A, #1E8E6F)',
      glowColor: '#28C08A',
      link: '/find-doctors'
    },
    {
      id: 3,
      icon: LabTestsIcon,
      title: 'Lab Tests',
      description: 'Home sample collection with safe & trusted services',
      badge: 'Safe & Trusted',
      badgeColor: '#286CFF',
      gradient: 'linear-gradient(135deg, #E3EDFF 0%, #EEF4FF 100%)',
      borderGradient: 'linear-gradient(135deg, #286CFF, #1E5ABF)',
      glowColor: '#286CFF',
      link: '#'
    },
    {
      id: 4,
      icon: BookAppointmentsIcon,
      title: 'Book Appointments',
      description: 'Schedule at your convenience with easy booking',
      badge: 'Easy Booking',
      badgeColor: '#FFB800',
      gradient: 'linear-gradient(135deg, #FFF4E3 0%, #FFF9F0 100%)',
      borderGradient: 'linear-gradient(135deg, #FFD28A, #FFA94D)',
      glowColor: '#FFD28A',
      link: '/find-doctors'
    }
  ];

  // Check if mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Handle carousel scroll
  const handleScroll = () => {
    if (carouselRef.current && isMobile) {
      const scrollLeft = carouselRef.current.scrollLeft;
      const cardWidth = carouselRef.current.offsetWidth;
      const newSlide = Math.round(scrollLeft / cardWidth);
      setCurrentSlide(newSlide);
    }
  };

  // Navigate to specific slide
  const goToSlide = (index) => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.offsetWidth;
      carouselRef.current.scrollTo({
        left: cardWidth * index,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        {isMobile ? (
          // Mobile Carousel View
          <div style={styles.carouselWrapper}>
            <div 
              ref={carouselRef}
              style={styles.carousel}
              onScroll={handleScroll}
            >
              {services.map((service) => {
                const IconComponent = service.icon;
                return (
                  <div
                    key={service.id}
                    onClick={() => service.link !== '#' && navigate(service.link)}
                    style={{
                      ...styles.carouselCard,
                      background: service.gradient,
                      border: '3px solid transparent',
                      backgroundImage: `${service.gradient}, ${service.borderGradient}`,
                      backgroundOrigin: 'border-box',
                      backgroundClip: 'padding-box, border-box',
                      cursor: service.link !== '#' ? 'pointer' : 'default'
                    }}
                  >
                    <div className="service-icon" style={styles.iconWrapper}>
                      <IconComponent />
                    </div>
                    <div style={{ ...styles.badge, background: service.badgeColor }}>
                      <Zap size={10} />
                      <span>{service.badge}</span>
                    </div>
                    <h3 style={styles.cardTitle}>{service.title}</h3>
                    <p style={styles.cardDescription}>{service.description}</p>
                  </div>
                );
              })}
            </div>
            
            {/* Carousel Dots */}
            <div style={styles.dotsContainer}>
              {services.map((_, index) => (
                <button
                  key={index}
                  onClick={() => goToSlide(index)}
                  style={{
                    ...styles.dot,
                    background: currentSlide === index ? '#286CFF' : '#D1D5DB',
                    width: currentSlide === index ? '32px' : '8px'
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        ) : (
          // Desktop Grid View
          <div style={styles.grid}>
            {services.map((service) => {
              const IconComponent = service.icon;
              return (
                <div
                  key={service.id}
                  onClick={() => service.link !== '#' && navigate(service.link)}
                  style={{
                    ...styles.card,
                    background: service.gradient,
                    border: '3px solid transparent',
                    backgroundImage: `${service.gradient}, ${service.borderGradient}`,
                    backgroundOrigin: 'border-box',
                    backgroundClip: 'padding-box, border-box',
                    cursor: service.link !== '#' ? 'pointer' : 'default'
                  }}
                  className="hover-lift"
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-12px) scale(1.03)';
                    e.currentTarget.style.boxShadow = `0 20px 50px ${service.glowColor}40, 0 0 0 4px ${service.glowColor}15`;
                    const icon = e.currentTarget.querySelector('.service-icon');
                    if (icon) {
                      icon.style.transform = 'scale(1.15) rotate(-5deg)';
                      icon.style.filter = 'drop-shadow(0 8px 16px rgba(40, 108, 255, 0.3))';
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0) scale(1)';
                    e.currentTarget.style.boxShadow = `0 12px 32px rgba(0, 0, 0, 0.12), 0 4px 12px ${service.glowColor}20`;
                    const icon = e.currentTarget.querySelector('.service-icon');
                    if (icon) {
                      icon.style.transform = 'scale(1) rotate(0deg)';
                      icon.style.filter = 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))';
                    }
                  }}
                >
                  <div className="service-icon" style={styles.iconWrapper}>
                    <IconComponent />
                  </div>
                  <div style={{ ...styles.badge, background: service.badgeColor }}>
                    <Zap size={10} />
                    <span>{service.badge}</span>
                  </div>
                  <h3 style={styles.cardTitle}>{service.title}</h3>
                  <p style={styles.cardDescription}>{service.description}</p>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '80px 0',
    background: 'linear-gradient(180deg, #FAFBFF 0%, #FFFFFF 100%)',
    marginTop: '-50px',
    position: 'relative',
    zIndex: 10
  },
  container: {
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 32px'
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '24px'
  },
  carouselWrapper: {
    position: 'relative',
    width: '100%'
  },
  carousel: {
    display: 'flex',
    overflowX: 'scroll',
    scrollSnapType: 'x mandatory',
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    WebkitOverflowScrolling: 'touch',
    gap: '16px',
    padding: '8px 0 32px'
  },
  carouselCard: {
    minWidth: '100%',
    maxWidth: '100%',
    scrollSnapAlign: 'center',
    borderRadius: '28px',
    padding: '40px 24px',
    textAlign: 'center',
    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(40, 108, 255, 0.1)',
    flexShrink: 0
  },
  card: {
    borderRadius: '28px',
    padding: '4px',
    textAlign: 'center',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    cursor: 'pointer',
    position: 'relative',
    boxShadow: '0 12px 32px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(40, 108, 255, 0.1)'
  },
  iconWrapper: {
    width: '80px',
    height: '80px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
    transform: 'scale(1) rotate(0deg)',
    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
    filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))',
    background: 'white',
    borderRadius: '20px',
    padding: '8px'
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    color: 'white',
    padding: '6px 16px',
    borderRadius: '16px',
    fontSize: '11px',
    fontWeight: '700',
    marginBottom: '16px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
  },
  cardTitle: {
    fontSize: '19px',
    fontWeight: '700',
    color: '#1A202C',
    marginBottom: '12px',
    lineHeight: '1.3',
    padding: '0 8px'
  },
  cardDescription: {
    fontSize: '14px',
    color: '#64748B',
    lineHeight: '1.6',
    padding: '0 12px 8px'
  },
  dotsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    marginTop: '20px'
  },
  dot: {
    height: '8px',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    padding: 0
  }
};

// Hide scrollbar
const styleSheet = document.styleSheets[0];
if (styleSheet) {
  try {
    styleSheet.insertRule(`
      .carousel::-webkit-scrollbar {
        display: none;
      }
    `, styleSheet.cssRules.length);
  } catch (e) {
    // Ignore if rule already exists
  }
}

export default QuickServices;
